import { render, staticRenderFns } from "./DownloadImagensSelo.vue?vue&type=template&id=9c5f55a4&scoped=true"
import script from "./DownloadImagensSelo.vue?vue&type=script&lang=js"
export * from "./DownloadImagensSelo.vue?vue&type=script&lang=js"
import style0 from "./DownloadImagensSelo.vue?vue&type=style&index=0&id=9c5f55a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5f55a4",
  null
  
)

export default component.exports